import { MediaPlayer } from '@dixa/lib-shared-habla';
import type { MessageFile } from 'lib-shared-types-api';

type InstagramStoryVideoProps = {
  readonly attachment: MessageFile;
  readonly onError: () => void;
};

export const InstagramStoryVideo = ({
  attachment: { url: src, pretty_name: filename },
  onError,
}: InstagramStoryVideoProps): JSX.Element => (
  <MediaPlayer
    controls={{ download: false }}
    mediaFile={{ src, type: 'video' }}
    filename={filename}
    onError={onError}
  />
);
